var map = {
	"./1.png": "6XdX",
	"./2.png": "MxaQ",
	"./3.png": "F3mb",
	"./4.png": "M36D",
	"./5.png": "TsRu",
	"./m/1.png": "JZ2C",
	"./m/2.png": "1oBD",
	"./m/3.png": "2x3N",
	"./m/4.png": "o12d"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0zos";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar ^\.\/.*\.png$
// module id = 0zos
// module chunks = 1